import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';

import WithAgeValidation from '@shopDetails/HOCs/WithAgeValidation';
import { goBack, redirect, showNeutralToast, pushPage } from '@shared/actions';
import { getShopMaxProductQuantity } from '@conversion/selectors';
import getHasCart from '@core/reducers/cart/selectors/getHasCart';
import addLine from '@core/reducers/cart/actions/addLine';
import addLines from '@core/reducers/cart/actions/addLines';
import updateLine from '@core/reducers/cart/actions/updateLine';
import deleteLines from '@core/reducers/cart/actions/deleteLines';
import getCartItemInEdition from '@core/reducers/cart/selectors/getCartItemInEdition';
import getShop from '@core/reducers/shop/selectors/getShop';
import getCountryAgeRestriction from '@location/selectors/getCountryAgeRestriction';
import fetchProductConfig from '@productConfig/actions/fetchProductConfig';
import resetModule from '@productConfig/actions/resetModule';
import trackProductConfiguration from '@productConfig/tracking/actions/trackProductConfiguration';
import fetchProductsOptionsReplace from '@core/reducers/cart/actions/fetchProductsOptionsReplace';
import getProduct from '@productConfig/selectors/getProduct';
import { getRedirectToShopDetails } from '@shopDetails/selectors';
import register from '@productConfig/register';
import getCartProductQuantity from '@core/reducers/cart/selectors/getCartProductQuantity';
import getCartTotalProductsQuantity from '@core/reducers/cart/selectors/getCartTotalProductsQuantity';
import getIsShelvesMenuLayout from '@core/reducers/menu/selectors/getIsShelvesMenuLayout';
import getProductNutritionLabes from '@core/reducers/menu/selectors/getProductNutritionLabes';
import getCartItemInEditionFromShop from '@core/reducers/cart/selectors/getCartItemInEditionFromShop';
import fetchVendorNotesConfig from '@core/reducers/shop/actions/fetchVendorNotesConfig';
import { getShowNotes } from '@core/reducers/shop/selectors/getVendorConfig';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import fetchProductCrossSelling from '@productConfig/actions/fetchProductCrossSelling';
import fetchProductOptions from '@productConfig/actions/fetchProductOptions';

import getIsQuickCommerce from '@core/reducers/menu/selectors/getIsQuickCommerce';
import getDeeplink from '../../selectors/getDeepLink';
import messages from './messages';
import getIsNotOrganicFlow from '../../selectors/getIsNotOrganicFlow';
import fetchProductNearUser from '../../actions/fetchProductNearUser';

register();

const mapStateToProps = (state, { match, productId }) => ({
  product: getProduct(state),
  shop: getShop(state),
  cartItemInEdition: getIsQuickCommerce(state)
    ? getCartItemInEditionFromShop(state, {
        productId:
          productId || getCartItemInEdition(state, match?.params)?.product,
      })
    : getCartItemInEdition(state, match?.params),
  withOverlay: getIsShelvesMenuLayout(state),
  redirectToShopDetails: getRedirectToShopDetails(state),
  hasCart: getHasCart(state),
  productQuantity: getCartProductQuantity(state, {
    productId: productId || getCartItemInEdition(state, match?.params)?.product,
  }),
  shopMaxProducts: getShopMaxProductQuantity(state),
  cartTotalProductsQuantity: getCartTotalProductsQuantity(state),
  ageRestriction: getCountryAgeRestriction(state),
  nutritionInfo: getProductNutritionLabes(state),
  showNotes: getShowNotes(state),
  shopBusinessType: getShopBusinessType(state),
  isQC: getIsQuickCommerce(state),
  deepLink: getDeeplink(state),
  isNotOrganicFlow: getIsNotOrganicFlow(state),
});

const mapDispatchToProps = {
  fetchProductCrossSelling,
  addLine,
  addLines,
  updateLine,
  deleteLines,
  goBack,
  redirect,
  resetModule,
  showNeutralToast,
  trackProductConfiguration,
  pushPage,
  fetchVendorNotesConfig,
  fetchProductsOptionsReplace,
  fetchProductConfig,
  fetchProductOptions,
  fetchProductNearUser,
};

const withAgeValidation = T =>
  WithAgeValidation(T, {
    errorMsg: messages.product_configuration_age_validation_error,
    subtitle: messages.product_configuration_age_validation_subtitle,
  });

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withAgeValidation, withConnect, withIntl);
